import { useState } from "react";

import { FormErrorMessage, useToast, Flex } from "@chakra-ui/react";
import { MotionBox as Box } from "utils/motion";
import { useCookie } from "utils/cookieHelper";
import { useForm } from "react-hook-form";
import {
  submitFormV2,
  getSuccessToastData,
  tagEventForm,
} from "utils/formHelper";

import Trans, { useFormatMessage } from "components/base/Trans";
import Button from "components/base/Button";
import FormInput from "components/base/FormInput";

const extraData = { interest: "news" };

const FormSubscribe = (props) => {
  const formatMessage = useFormatMessage();
  const formId = "registration";

  const toast = useToast();
  const toastData = getSuccessToastData(
    formatMessage({ id: "LBL_FORM_SUBSCRIBE_SUCCESS_TITLE" }),
    formatMessage({ id: "LBL_FORM_SUBSCRIBE_SUCCESS_DESCRIPTION" }),
  );

  const defaultFormValues = { email: "" };

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [suggestion, setSuggestion] = useState(null);
  const {
    reset,
    watch,
    control,
    handleSubmit,
    errors: formErrors,
    setError: setFromError,
    register,
    formState,
    setValue,
    clearErrors,
  } = useForm({ defaultValues: defaultFormValues });
  const isDisabled = formState.isSubmitting || loading;
  const watchEmail = watch("email", null);

  const cookie = useCookie(props.cookie);

  const onSuccess = (values, res) => {
    setLoading(false);
    setValue("email", "");
    reset();
    toast(toastData);
    tagEventForm(values.email, null, null, res?.pid || null, ["Subscribe"]);
  };

  const onError = (type) => {
    if (type === "email" || type.email) {
      setFromError("email", { type: "manual" });
      if (type.suggestion) {
        setSuggestion(type.suggestion);
      }
    } else {
      setError(true);
    }
    setLoading(false);
  };

  return (
    <Box
      as="form"
      onSubmit={handleSubmit((data) => {
        setError(false);
        clearErrors("email");
        setLoading(true);
        submitFormV2(data, extraData, formId, onSuccess, onError, cookie);
      })}
    >
      <Flex
        gap={[3, null, null, 3]}
        justifyItems={["center", null, null, "left"]}
        alignItems={["end", null, null, "start"]}
        direction={["column", null, "row", "column"]}
      >
        <Box position="relative" width="100%">
          <FormInput
            control={control}
            id="email-subscribe"
            type="email"
            name="email"
            isInvalid={error || formErrors.email}
            isDisabled={isDisabled}
            isRequired
            rules={{ required: true }}
            formError={formErrors.email}
            label={<Trans id="LBL_FORM_REGISTER_EMAIL" />}
            errorLabel={<Trans id="LBL_FORM_REGISTER_EMAIL_ERROR" />}
            suggestion={suggestion}
            onSuggestionClick={() => {
              setValue("email", suggestion);
              setSuggestion(null);
              setError(false);
              clearErrors("email");
            }}
            fontSize={["12px", "14px", "16px"]}
            paddingRight={["92px", "92px", "116px"]}
            paddingLeft={["6px", "8px", "12px"]}
          />
          <Box
            position="absolute"
            right={["6px", "8px", "12px"]}
            bottom="12px"
            opacity={watchEmail?.length > 0 ? 1 : 0.6}
          >
            <Button
              variant="link_bt"
              type="submit"
              isLoading={formState.isSubmitting || loading}
              style={{ textTransform: "uppercase" }}
            >
              <Trans id="LBL_FORM_SUBSCRIBE" />
            </Button>
          </Box>
        </Box>
        {error && (
          <FormErrorMessage>
            <Trans id="LBL_FORM_SUBSCRIBE_ERROR" />
          </FormErrorMessage>
        )}
      </Flex>
    </Box>
  );
};

export default FormSubscribe;
